import { atom } from "jotai";

export const loadingChatMessageState = atom(false);